import { Outlet } from "react-router-dom";

const ProtectedRoute = ({ token }) => {
	// Route will only be available if there is a token
	return token && <Outlet />;
};

export default ProtectedRoute;
